
import Vue from 'vue'

const axios = require("axios")
import config from '@/config'


function resetState(state) {
   Object.assign(state, {
      // persisted in model ShdlModule
      modules: {},
      user2moduleList: {},
      team2moduleList: {},

      // not persisted in database
      module2parseInfo: {},
   })
}

const state = {}
resetState(state)

const mutations = {

   RESET_STATE (state) {
      //console.log('craps/RESET_STATE')
      resetState(state)
   },

   // between userId and teamId, one is null and the other is not
   SET_CRAPS_MODULES (state, { userId, teamId, modules }) {
      modules.forEach(module => {
         state.modules[module.id] = module
      })
      if (userId) {
         Vue.set(state.user2moduleList, userId, modules.map(module => module.id))
      }
      if (teamId) {
         Vue.set(state.team2moduleList, teamId, modules.map(module => module.id))
      }
   },

   ADD_CRAPS_MODULE (state, module) {
      // add module to state.modules
      Vue.set(state.modules, module.id, module)
      if (module.user) {
         // add module to state.user2moduleList
         if (!state.user2moduleList.hasOwnProperty(module.user)) Vue.set(state.user2moduleList, module.user, [])
         // simply push it: sorting is done in UI
         state.user2moduleList[module.user].push(module.id)
         Vue.set(state.user2moduleList, module.user, state.user2moduleList[module.user])
      }
      if (module.team) {
         // add module to state.team2moduleList
         if (!state.team2moduleList.hasOwnProperty(module.team)) Vue.set(state.team2moduleList, module.team, [])
         // simply push it: sorting is done in UI
         state.team2moduleList[module.team].push(module.id)
         Vue.set(state.team2moduleList, module.team, state.team2moduleList[module.team])
      }
   },

   UPDATE_CRAPS_MODULE (state, module) {
      Vue.set(state.modules, module.id, module)
      Vue.set(state.user2moduleList, module.user, state.user2moduleList[module.user])
   },

   REMOVE_CRAPS_MODULE (state, module) {
      if (module.user) {
         let index = state.user2moduleList[module.user].indexOf(module.id)
         Vue.delete(state.user2moduleList[module.user], index)
      }
      if (module.team) {
         let index = state.team2moduleList[module.team].indexOf(module.id)
         Vue.delete(state.team2moduleList[module.team], index)
      }
      Vue.delete(state.modules, module.id)
   },

   // this mutation allows to store additionnal info on modules (parsing, checking etc.), which are not saved in database
   UPDATE_MODULE_PARSE_INFO (state, { moduleId, memory, symbols, isOk }) {
      Vue.set(state.module2parseInfo, moduleId, {
         memory: memory,
         symbols: symbols,
         isOk: isOk,
      })
   }
}

const actions = {

   // between userId and teamId, one is null and the other is not
   GET_CRAPS_MODULES ({ commit, rootState }, { userId, teamId }) {
      let queryParams
      if (userId) {
         queryParams = `user=${userId}`
      }
      if (teamId) {
         queryParams = `team=${teamId}`
      }
      return axios({
         method: 'get',
         url: `${config.CRAPS_MODULES_URL}?${queryParams}`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         let shdlModulesDict = { userId: userId, teamId: teamId, modules: response.data }
         commit('SET_CRAPS_MODULES', shdlModulesDict)
         return response.data
      })
   },
   
   POST_CRAPS_MODULE ({ commit, rootState }, module) {
      return axios({
         method: 'post',
         url: config.CRAPS_MODULES_URL,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
         data: module,
      })
      .then(function(response) {
         commit('ADD_CRAPS_MODULE', response.data)
         return response.data
      })
   },
   
   PUT_CRAPS_MODULE ({ commit, rootState }, module) {
      return axios({
         method: 'put',
         url: `${config.CRAPS_MODULES_URL}${module.id}/`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
         data: module,
      })
      .then(function(response) {
         commit('UPDATE_CRAPS_MODULE', response.data)
         return response.data
      })
   },

   DELETE_CRAPS_MODULE ({ commit, rootState }, module) {
      return axios({
         method: 'delete',
         url: `${config.CRAPS_MODULES_URL}${module.id}/`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         commit('REMOVE_CRAPS_MODULE', module)
         return module
      })
   },
}

const getters = {

}

export default {
   namespaced: true,
   state,
   mutations,
   actions,
   getters,
}



// WEBPACK FOOTER //
// ./src/store/craps/index.js